@switch (selectedTab) { @case ('home') { @if (!isParent) {
<app-new-home-tab [workplace]="workplace" [meta]="tilesData?.meta" data-testid="home-tab"></app-new-home-tab>
} @else {
<app-parent-home-tab [workplace]="workplace" [meta]="tilesData?.meta" data-testid="parentHomeTab"></app-parent-home-tab>
} } @case ('workplace') { @if (canViewEstablishment && workplace) {
<app-new-workplace-tab
  [workplace]="workplace"
  [workerCount]="workerCount"
  data-testid="workplace-tab"
></app-new-workplace-tab>
} } @case ('staff-records') { @if (canViewListOfWorkers && workplace) {
<app-new-staff-tab
  [workplace]="workplace"
  [workers]="workers"
  [workerCount]="workerCount"
  [staffLastUpdated]="staffLastUpdatedDate"
  data-testid="staff-records-tab"
></app-new-staff-tab>
} } @case ('training-and-qualifications') { @if (canViewListOfWorkers && workplace) {
<app-new-training-tab
  [workplace]="workplace"
  [workers]="workers"
  [workerCount]="workerCount"
  [trainingCounts]="trainingCounts"
  [tAndQsLastUpdated]="tAndQsLastUpdated"
  [hasTrainingCourse]="hasTrainingCourse"
  data-testid="training-and-qualifications-tab"
></app-new-training-tab>
} } @case ('benchmarks') { @if (canSeeNewDataArea) {
<app-data-area-tab [workplace]="workplace" [newDashboard]="true" data-testid="data-area-tab"></app-data-area-tab>
} @else {
<app-new-benchmarks-tab
  class="asc-benchmarks-tab"
  [workplace]="workplace"
  [isParentViewingSubsidiary]="false"
  data-testid="benchmarks-tab"
></app-new-benchmarks-tab>
} } }
